var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicFill0Wght400Grad0Opsz241({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C22.3333 28 20.9167 27.4167 19.75 26.25C18.5833 25.0833 18 23.6667 18 22V10C18 8.33333 18.5833 6.91667 19.75 5.75C20.9167 4.58333 22.3333 4 24 4C25.6667 4 27.0833 4.58333 28.25 5.75C29.4167 6.91667 30 8.33333 30 10V22C30 23.6667 29.4167 25.0833 28.25 26.25C27.0833 27.4167 25.6667 28 24 28ZM22 42V35.85C18.5333 35.3833 15.6667 33.8333 13.4 31.2C11.1333 28.5667 10 25.5 10 22H14C14 24.7667 14.975 27.125 16.925 29.075C18.875 31.025 21.2333 32 24 32C26.7667 32 29.125 31.025 31.075 29.075C33.025 27.125 34 24.7667 34 22H38C38 25.5 36.8667 28.5667 34.6 31.2C32.3333 33.8333 29.4667 35.3833 26 35.85V42H22ZM24 24C24.5667 24 25.0417 23.8083 25.425 23.425C25.8083 23.0417 26 22.5667 26 22V10C26 9.43333 25.8083 8.95833 25.425 8.575C25.0417 8.19167 24.5667 8 24 8C23.4333 8 22.9583 8.19167 22.575 8.575C22.1917 8.95833 22 9.43333 22 10V22C22 22.5667 22.1917 23.0417 22.575 23.425C22.9583 23.8083 23.4333 24 24 24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicFill0Wght400Grad0Opsz241);
export default __webpack_public_path__ + "static/media/mic_FILL0_wght400_GRAD0_opsz24 1.6a367cc601a7671f9e93ab0c5ae25d24.svg";
export { ForwardRef as ReactComponent };